export const CHART_COLORS = [
  "#16A34A",
  "#2563EB",
  "#D97706",
  "#7C3AED",
  "#0F766E",
  "#DC2626",
  "#475569",
  "#DB2777",
];

export const metricValue = (metric) => {
  if (metric == null || metric === "") return null;
  if (typeof metric === "number" || typeof metric === "string") return metric;
  return metric.value ?? null;
};

export const formatCount = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "---";
  return amount.toLocaleString();
};

export const formatPercent = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "---";
  return `${amount.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`;
};

export const formatMoney = (value, currency = "GHS") => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "---";
  const formatted = amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const code = String(currency || "GHS").trim().toUpperCase();
  if (code === "USD") return `$${formatted}`;
  if (code === "GHS") return `₵${formatted}`;
  return `${code} ${formatted}`;
};

export const buildSlices = (items, labelKey, valueKey) => {
  const rows = (Array.isArray(items) ? items : [])
    .map((item) => ({
      label: item?.[labelKey] || "Unknown",
      value: Number(item?.[valueKey]) || 0,
      percentage: item?.percentage == null ? null : Number(item.percentage),
    }))
    .filter((item) => item.value > 0);

  const total = rows.reduce((sum, row) => sum + row.value, 0);
  if (rows.length === 0) {
    return {
      empty: true,
      labels: ["No data"],
      values: [1],
      colors: ["#E5E7EB"],
      rows: [],
      total: 0,
    };
  }

  return {
    empty: false,
    labels: rows.map((row) => row.label),
    values: rows.map((row) => row.value),
    colors: rows.map((_, index) => CHART_COLORS[index % CHART_COLORS.length]),
    rows: rows.map((row) => ({
      ...row,
      percentage: Number.isFinite(row.percentage)
        ? row.percentage
        : total
          ? (row.value / total) * 100
          : 0,
    })),
    total,
  };
};
